export default __webpack_public_path__ + "static/media/moneycard.1536c02f.jpg";